module.exports = __webpack_public_path__ + "img/NL353.65bdcac1.png";